"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { XIcon } from "lucide-react";
import { IconDeviceDesktopDown } from "@tabler/icons-react";
import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
export default function PwaToast() {
  const {
    t
  } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 768) {
      setVisible(false);
    }
  }, []);
  useEffect(() => {
    const beforeInstallHandler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", beforeInstallHandler);
    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstallHandler);
    };
  }, []);
  useEffect(() => {
    const toastShown = localStorage.getItem("pwaToastShown");
    if (!toastShown && deferredPrompt) {
      setVisible(true);
    }
  }, [deferredPrompt]);
  const handleAddToHome = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        localStorage.setItem("pwaToastShown", "true");
        setVisible(false);
      });
    }
  };
  const handleDismissToast = () => {
    localStorage.setItem("pwaToastShown", "true");
    setVisible(false);
  };
  if (!visible) return null;
  return <>
      <motion.div className="fixed top-4 right-4 z-50 hidden lg:block" initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: "easeOut"
    }} data-sentry-element="unknown" data-sentry-source-file="pwa-alert.tsx">
        <div className="bg-background max-w-[400px] rounded-md border p-4 shadow-lg">
          <div className="flex gap-3">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border" aria-hidden="true">
              <IconDeviceDesktopDown stroke={2} data-sentry-element="IconDeviceDesktopDown" data-sentry-source-file="pwa-alert.tsx" />
            </div>
            <div className="flex grow flex-col gap-3">
              <div className="space-y-1">
                <p className="text-sm font-medium">
                {t('common:text-pwa-toast-title')}
                </p>
              </div>
              <div className="flex gap-2">
                <Button size="sm" onClick={handleAddToHome} data-sentry-element="Button" data-sentry-source-file="pwa-alert.tsx">
                {t('common:text-pwa-toast-button')}
                </Button>
              </div>
            </div>
            <Button variant="ghost" className="group -my-1.5 -me-2 h-8 w-8 shrink-0 p-0 hover:bg-transparent" aria-label="Close notification" onClick={handleDismissToast} data-sentry-element="Button" data-sentry-source-file="pwa-alert.tsx">
              <XIcon size={16} className="opacity-60 transition-opacity group-hover:opacity-100" aria-hidden="true" data-sentry-element="XIcon" data-sentry-source-file="pwa-alert.tsx" />
            </Button>
          </div>
        </div>
      </motion.div>
    </>;
}